
export const ProductListInput = (esitoProdotti: {value:string, label:string}[]) =>([
    {
        label: 'Nome prodotto',
        name: 'nome',
        placeholder: 'Nome prodotto',
        type: 'text',
        validators: {
            required: 'Il nome è obbligatorio'
        },
        type_input: 'input',
        size_input: 'w-full',
    },
    {
        label: 'Prezzo',
        name: 'prezzoConsigliato',
        placeholder: 'Prezzo',
        type: 'text',
        validators: {
            required: 'Il prezzo è obbligatorio',
            validate: (value: string) => value !== '0' || 'Il prezzo deve essere maggiore di zero'
        },
        type_input: 'input',
        size_input: 'w-full',
    },
    {
        label: 'Esito',
        name: 'esito',
        placeholder: 'Esito',
        type: 'text',
        validators: {
            required: 'Il campo è obbligatorio'
        },
        type_input: 'react-select',
        size_input: 'w-full',
        options: esitoProdotti
    },
    {
        label: 'Visibile nei report solo agli admin',
        name: 'isReportAdminOnly',
        placeholder: 'Visibile nei report solo agli admin',
        type: 'checkbox',
        validators: {},
        type_input: 'checkbox',
        size_input: 'w-full',
    }
])